import React from 'react';
import './SetupSecurity.css'

function SetupSecurity () {
    
        return (
            <div>
     <div className="">
    <div className="securityPageWrapper">

        {/* <!-- HEADER --> */}
        <div className="securityHeaderWrapper">
            <h2 className="securityHeaderTitle">Cấu hình bảo mật</h2>

            <div className="securityBreadcrumbWrapper">
                <span className="securityBreadcrumbItem">Trang chủ</span>
                <span className="securityBreadcrumbSlash">/</span>

                <span className="securityBreadcrumbItem">Cấu hình hệ thống</span>
                <span className="securityBreadcrumbSlash">/</span>

                <span className="securityBreadcrumbActive">Cấu hình bảo mật</span>
            </div>
        </div>

        {/* <!-- GRID --> */}
        <div className="securityGridWrapper">

            {/* <!-- LEFT --> */}
            <div className="securityLeftColumn">

                {/* <!-- PASSWORD POLICY --> */}
                <div className="securityCardPassword">

                    <div className="securityCardTitle">
                        Chính sách mật khẩu
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Độ dài tối thiểu của mật khẩu
                        </div>

                        <div className="securityInputGroup">
                            <input
                                type="text"
                                value="8"
                                className="securityTextInput"
                            />
                            <span className="securityInputUnit">ký tự</span>
                        </div>
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Yêu cầu chữ hoa
                        </div>

                        <label className="securitySwitchWrapper">
                            <input
                                type="checkbox"
                                checked
                                className="securitySwitchInput"
                            />
                            <span className="securitySwitchSlider"></span>
                        </label>
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Yêu cầu chữ thường
                        </div>

                        <label className="securitySwitchWrapper">
                            <input
                                type="checkbox"
                                checked
                                className="securitySwitchInput"
                            />
                            <span className="securitySwitchSlider"></span>
                        </label>
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Yêu cầu chữ số
                        </div>

                        <label className="securitySwitchWrapper">
                            <input
                                type="checkbox"
                                checked
                                className="securitySwitchInput"
                            />
                            <span className="securitySwitchSlider"></span>
                        </label>
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Yêu cầu chữ ký tự đặc biệt
                        </div>

                        <label className="securitySwitchWrapper">
                            <input
                                type="checkbox"
                                checked
                                className="securitySwitchInput"
                            />
                            <span className="securitySwitchSlider"></span>
                        </label>
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Thời gian hết hạn mật khẩu
                        </div>

                        <div className="securityInputGroup">
                            <input
                                type="text"
                                value="90"
                                className="securityTextInput"
                            />
                            <span className="securityInputUnit">ngày</span>
                        </div>
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Không cho phép trùng mật khẩu gần nhất
                        </div>

                        <div className="securityInputGroup">
                            <input
                                type="text"
                                value="5"
                                className="securityTextInput"
                            />
                            <span className="securityInputUnit">lần</span>
                        </div>
                    </div>

                </div>

                {/* <!-- 2FA --> */}
                <div className="securityCardTwoFactor">

                    <div className="securityCardTitle">
                        Xác thực 2 lớp (2FA)
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Bật xác thực 2 lớp
                        </div>

                        <label className="securitySwitchWrapper">
                            <input
                                type="checkbox"
                                checked
                                className="securitySwitchInput"
                            />
                            <span className="securitySwitchSlider"></span>
                        </label>
                    </div>

                    <div className="securityTwoFactorMethods">

                        <div className="securityCheckboxItem">
                            <input
                                type="checkbox"
                                checked
                                className="securityCheckboxInput"
                            />
                            <span className="securityCheckboxLabel">
                                Google Authenticator
                            </span>
                        </div>

                        <div className="securityCheckboxItem">
                            <input
                                type="checkbox"
                                checked
                                className="securityCheckboxInput"
                            />
                            <span className="securityCheckboxLabel">
                                SMS
                            </span>
                        </div>

                        <div className="securityCheckboxItem">
                            <input
                                type="checkbox"
                                className="securityCheckboxInput"
                            />
                            <span className="securityCheckboxLabel">
                                Email
                            </span>
                        </div>

                    </div>

                </div>

                {/* <!-- DATA --> */}
                <div className="securityCardDataProtection">

                    <div className="securityCardTitle">
                        Bảo vệ dữ liệu
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Mã hóa dữ liệu nhạy cảm
                        </div>

                        <div className="securityRightAction">
                            <label className="securitySwitchWrapper">
                                <input
                                    type="checkbox"
                                    checked
                                    className="securitySwitchInput"
                                />
                                <span className="securitySwitchSlider"></span>
                            </label>

                            <span className="securityInfoIcon">i</span>
                        </div>
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Ẩn thông tin cá nhân trong nhật ký
                        </div>

                        <div className="securityRightAction">
                            <label className="securitySwitchWrapper">
                                <input
                                    type="checkbox"
                                    checked
                                    className="securitySwitchInput"
                                />
                                <span className="securitySwitchSlider"></span>
                            </label>

                            <span className="securityInfoIcon">i</span>
                        </div>
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Giới hạn tải dữ liệu
                        </div>

                        <div className="securityInputGroup">
                            <input
                                type="text"
                                value="1000"
                                className="securityTextInput"
                            />
                            <span className="securityInputUnit">
                                bản ghi/lần
                            </span>
                        </div>
                    </div>

                    <div className="securityFileTypeWrapper">

                        <div className="securityLabelText">
                            Cho phép tải file dữ liệu
                        </div>

                        <div className="securityFileTypeList">

                            <div className="securityCheckboxItem">
                                <input
                                    type="checkbox"
                                    checked
                                    className="securityCheckboxInput"
                                />
                                <span className="securityCheckboxLabel">
                                    Excel
                                </span>
                            </div>

                            <div className="securityCheckboxItem">
                                <input
                                    type="checkbox"
                                    checked
                                    className="securityCheckboxInput"
                                />
                                <span className="securityCheckboxLabel">
                                    PDF
                                </span>
                            </div>

                            <div className="securityCheckboxItem">
                                <input
                                    type="checkbox"
                                    checked
                                    className="securityCheckboxInput"
                                />
                                <span className="securityCheckboxLabel">
                                    CSV
                                </span>
                            </div>

                        </div>

                    </div>

                </div>

                {/* <!-- OTHER --> */}
                <div className="securityCardOtherOption">

                    <div className="securityCardTitle">
                        Các tùy chọn bảo mật khác
                    </div>

                    <div className="securityOtherGrid">

                        <div className="securityOtherItem">

                            <div className="securityLabelText">
                                Thông báo đăng nhập từ thiết bị mới
                            </div>

                            <div className="securityRightAction">
                                <label className="securitySwitchWrapper">
                                    <input
                                        type="checkbox"
                                        checked
                                        className="securitySwitchInput"
                                    />
                                    <span className="securitySwitchSlider"></span>
                                </label>

                                <span className="securityInfoIcon">i</span>
                            </div>

                        </div>

                        <div className="securityOtherItem">

                            <div className="securityLabelText">
                                Kiểm tra rò rỉ mật khẩu
                            </div>

                            <div className="securityRightAction">
                                <label className="securitySwitchWrapper">
                                    <input
                                        type="checkbox"
                                        checked
                                        className="securitySwitchInput"
                                    />
                                    <span className="securitySwitchSlider"></span>
                                </label>

                                <span className="securityInfoIcon">i</span>
                            </div>

                        </div>

                        <div className="securityOtherItem">

                            <div className="securityLabelText">
                                Yêu cầu xác nhận khi đăng nhập từ thiết bị lạ
                            </div>

                            <div className="securityRightAction">
                                <label className="securitySwitchWrapper">
                                    <input
                                        type="checkbox"
                                        checked
                                        className="securitySwitchInput"
                                    />
                                    <span className="securitySwitchSlider"></span>
                                </label>

                                <span className="securityInfoIcon">i</span>
                            </div>

                        </div>

                        <div className="securityOtherItem">

                            <div className="securityLabelText">
                                Gửi cảnh báo bảo mật qua email
                            </div>

                            <div className="securityRightAction">
                                <label className="securitySwitchWrapper">
                                    <input
                                        type="checkbox"
                                        checked
                                        className="securitySwitchInput"
                                    />
                                    <span className="securitySwitchSlider"></span>
                                </label>
                            </div>

                        </div>

                    </div>

                </div>

            </div>

            {/* <!-- RIGHT --> */}
            <div className="securityRightColumn">

                {/* <!-- LOGIN POLICY --> */}
                <div className="securityCardLoginPolicyRight">

                    <div className="securityCardTitle">
                        Chính sách đăng nhập
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Số lần đăng nhập sai tối đa
                        </div>

                        <div className="securityInputGroup">
                            <input
                                type="text"
                                value="5"
                                className="securityTextInput"
                            />
                            <span className="securityInputUnit">lần</span>
                        </div>
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Thời gian khóa tài khoản
                        </div>

                        <div className="securityInputGroup">
                            <input
                                type="text"
                                value="30"
                                className="securityTextInput"
                            />
                            <span className="securityInputUnit">phút</span>
                        </div>
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Tự động đăng xuất sau thời gian không hoạt động
                        </div>

                        <div className="securityInputGroup">
                            <input
                                type="text"
                                value="30"
                                className="securityTextInput"
                            />
                            <span className="securityInputUnit">phút</span>
                        </div>
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Hiển thị CAPTCHA khi đăng nhập
                        </div>

                        <label className="securitySwitchWrapper">
                            <input
                                type="checkbox"
                                checked
                                className="securitySwitchInput"
                            />
                            <span className="securitySwitchSlider"></span>
                        </label>
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Cho phép đăng nhập đồng thời
                        </div>

                        <label className="securitySwitchWrapper">
                            <input
                                type="checkbox"
                                checked
                                className="securitySwitchInput"
                            />
                            <span className="securitySwitchSlider"></span>
                        </label>
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Số phiên đăng nhập tối đa trên mỗi tài khoản
                        </div>

                        <div className="securityInputGroup">
                            <input
                                type="text"
                                value="3"
                                className="securityTextInput"
                            />
                            <span className="securityInputUnit">phiên</span>
                        </div>
                    </div>

                </div>

                {/* <!-- SESSION --> */}
                <div className="securityCardSessionRight">

                    <div className="securityCardTitle">
                        Phiên đăng nhập
                    </div>

                    <div className="securitySessionTop">

                        <div className="securityLabelText">
                            Quản lý phiên đăng nhập
                        </div>

                        <button className="securitySessionButton">
                            <i className="fa-solid fa-user-group icon-user-grup"></i>
                            Xem danh sách phiên
                        </button>

                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Kết thúc tất cả phiên khác khi đổi mật khẩu
                        </div>

                        <label className="securitySwitchWrapper">
                            <input
                                type="checkbox"
                                checked
                                className="securitySwitchInput"
                            />
                            <span className="securitySwitchSlider"></span>
                        </label>
                    </div>

                </div>

                {/* <!-- IP --> */}
                <div className="securityCardIpRight">

                    <div className="securityCardTitle">
                        Chính sách IP
                    </div>

                    <div className="securityRowItem">
                        <div className="securityLabelText">
                            Giới hạn đăng nhập theo địa chỉ IP
                        </div>

                        <label className="securitySwitchWrapper">
                            <input
                                type="checkbox"
                                checked
                                className="securitySwitchInput"
                            />
                            <span className="securitySwitchSlider"></span>
                        </label>
                    </div>

                    <div className="securityIpModeWrapper">

                        <div className="securityLabelText">
                            Chế độ
                        </div>

                        <div className="securityRadioList">

                            <label className="securityRadioItem">
                                <input
                                    type="radio"
                                    checked
                                    name="ipmode"
                                    className="securityRadioInput"
                                />
                                <span className="securityRadioLabel">
                                    Cho phép danh sách IP
                                </span>
                            </label>

                            <label className="securityRadioItem">
                                <input
                                    type="radio"
                                    name="ipmode"
                                    className="securityRadioInput"
                                />
                                <span className="securityRadioLabel">
                                    Chặn danh sách IP
                                </span>
                            </label>

                        </div>

                    </div>

                    <div className="securityTextareaWrapper">

                        <div className="securityLabelText">
                            Danh sách IP
                        </div>
                     
                        <textarea class="securityTextareaInput" rows="5" placeholder='192.168.1.0/24
                            10.0.0.0/8
                            113.160.0.0/16'>
                            
                        </textarea> 

                        <div className="securityTextareaNote">
                            Mỗi dòng nhập 1 IP hoặc dải IP (CIDR)
                        </div>

                    </div>

                </div>

            </div>

        </div>

        {/* <!-- FOOTER --> */}
        <div className="securityFooterAction">

            <button className="securityResetButton">
                <i className="fa-solid fa-arrows-rotate icon-lock-share"></i>
                Đặt lại về mặc định
            </button>

            <button className="securitySaveButton">
                <i className="fa-solid fa-lock icon-lock-share"></i>
                Lưu cấu hình
            </button>

        </div>

    </div>
</div>
            </div>
        );
    
}



export default SetupSecurity;